// Product Card Ring Size Validation
if (typeof ProductCardRingSizeValidation === 'undefined') {
  class ProductCardRingSizeValidation {
    constructor() {
      this.init();
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      if (window.productCardRingValidationBound) return;
      window.productCardRingValidationBound = true;

      // Handle form submissions (single variant products)
      document.addEventListener('submit', (e) => {
        if (e.target.classList.contains('product-card__add-to-cart--form')) {
          this.validateProductCardForm(e);
        }
      });

      // Handle quick cart drawer button clicks (multi-variant products)
      document.addEventListener('click', (e) => {
        if (e.target.classList.contains('quick-cart-drawer__trigger')) {
          this.validateQuickCartDrawer(e);
        }
      });
    }

    validateProductCardForm(event) {
      const form = event.target;
      const productCard = form.closest('product-card');

      if (!this.hasRingSizeSelector(productCard)) {
        return true; // No ring size selector, allow submission
      }

      if (!this.isRingSizeSelected(productCard)) {
        event.preventDefault();
        this.showRingSizeError(productCard);
        return false;
      }

      return true;
    }

    validateQuickCartDrawer(event) {
      const button = event.target;
      const productCard = button.closest('product-card');

      if (!this.hasRingSizeSelector(productCard)) {
        return true; // No ring size selector, allow click
      }

      if (!this.isRingSizeSelected(productCard)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.showRingSizeError(productCard);
        return false;
      }

      return true;
    }

    hasRingSizeSelector(productCard) {
      // Check if this product has ring size data attribute
      const hasRingSizeData = productCard.dataset.hasRingSizes === 'true';
      if (hasRingSizeData) {
        return true;
      }

      // Fallback: Check if the product title/type suggests it's a ring
      const productTitle = productCard.querySelector('.product-card__title')?.textContent?.toLowerCase() || '';
      const isRingProduct = productTitle.includes('ring') ||
                           productTitle.includes('band') ||
                           productTitle.includes('wedding') ||
                           productTitle.includes('engagement');

      return isRingProduct;
    }

    isRingSizeSelected(productCard) {
      // Since ring size selection happens on the product page, not the card,
      // we need to check if the user has previously selected a ring size
      // This could be implemented by checking localStorage, sessionStorage,
      // or by requiring users to go to the product page first

      // For now, we'll always return false to require users to visit the product page
      // where they can select the ring size before adding to cart
      return false;
    }

    getProductData(productCard) {
      const variantsScript = productCard.querySelector('script[data-product-variants-json]');
      if (variantsScript) {
        try {
          return JSON.parse(variantsScript.textContent);
        } catch (e) {
          return null;
        }
      }
      return null;
    }

    showRingSizeError(productCard) {
      // Remove any existing error messages
      this.clearRingSizeError(productCard);

      // Create error message
      const errorDiv = document.createElement('div');
      errorDiv.className = 'ring-size-error-card';
      errorDiv.style.cssText = `
        background: #c25151;
        color: white;
        padding: 0.75rem;
        margin-top: 0.5rem;
        border-radius: 4px;
        font-size: 0.875rem;
        font-weight: 500;
        text-align: center;
        width: 100%;
        box-sizing: border-box;
        animation: slideDown 0.3s ease-out;
        display: block;
      `;
      errorDiv.textContent = 'Please select ring size';

      // Add CSS animation
      if (!document.querySelector('#ring-size-error-styles')) {
        const style = document.createElement('style');
        style.id = 'ring-size-error-styles';
        style.textContent = `
          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          .ring-size-error-card {
            position: relative;
            z-index: 10;
          }
        `;
        document.head.appendChild(style);
      }

      // Find the best place to insert the error
      const productContent = productCard.querySelector('.product-card__content');
      const addToCartForm = productCard.querySelector('.product-card__add-to-cart--form');
      const quickCartButton = productCard.querySelector('.quick-cart-drawer__trigger');

      if (addToCartForm) {
        addToCartForm.appendChild(errorDiv);
      } else if (quickCartButton && quickCartButton.parentElement) {
        quickCartButton.parentElement.appendChild(errorDiv);
      } else if (productContent) {
        productContent.appendChild(errorDiv);
      }

      // Auto-remove after 4 seconds
      setTimeout(() => {
        this.clearRingSizeError(productCard);
      }, 4000);

      // Scroll to show the error
      errorDiv.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });
    }

    clearRingSizeError(productCard) {
      const existingErrors = productCard.querySelectorAll('.ring-size-error-card');
      existingErrors.forEach(error => error.remove());
    }
  }

  // Make globally available
  window.ProductCardRingSizeValidation = ProductCardRingSizeValidation;
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new (window.ProductCardRingSizeValidation || ProductCardRingSizeValidation)();
});

// Initialize for dynamic content
document.addEventListener('shopify:section:load', () => {
  new (window.ProductCardRingSizeValidation || ProductCardRingSizeValidation)();
});
